module.exports = __webpack_public_path__ + "static/img/banner_1.39e4551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/banner_1.png
// module id = SENd
// module chunks = 1